import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress CRA error overlay for cross-origin "Script error" from third-party scripts
// (PostHog, Zoho, etc.) that fail silently and don't affect app functionality
window.addEventListener("error", (e) => {
  if (e.message === "Script error." || e.message === "Script error") {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
